import { render, staticRenderFns } from "./chat_header.vue?vue&type=template&id=6dc06f96&scoped=true"
import script from "./chat_header.vue?vue&type=script&lang=js"
export * from "./chat_header.vue?vue&type=script&lang=js"
import style0 from "./chat_header.vue?vue&type=style&index=0&id=6dc06f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc06f96",
  null
  
)

export default component.exports